import { Table, TableHead, TableCell, TableRow, TableContainer, Paper } from "@mui/material";
import CustomTableBody from "../../../../../utilis/component/CustomTableBody";
import { BilledDetails } from "../../type";


const headers = [
  "Sl no",
  "Bill No",
  "Item Code",
  "Name",
  "Rate",
  "Unit",
  "Amount",
  "Discount Amount",
  "Ins Discount",
  "Ins Amount",
  "Pat Share",
  "Billed By",
];

const columnWidths = {
  "Bill No": "100px",
  "Sl no": "60px",
  "Item Code": "90px",
  "Name": "240px",
  "Rate": "80px",
  "Unit": "60px",
  "Amount": "100px",
  "Discount Amount": "110px",
  "Ins Discount": "100px",
  "Ins Amount": "100px",
  "Pat Share": "100px",
  "Billed By": "250px",
};

const DetailsTable = ({ data, isLoading }: { data: BilledDetails[]; isLoading: boolean }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        maxWidth: "60vw",
        overflowX: "auto",
        maxHeight: "400px",
        "&::-webkit-scrollbar": { height: "8px", width: "8px" },
        "&::-webkit-scrollbar-thumb": { backgroundColor: "#888" },
        p:2
      }}
    >
      <Table sx={{ tableLayout: "fixed", width: "100%" }}>
        <TableHead
          sx={(theme) => ({
            backgroundColor: theme.palette.primary.main,
            position: "sticky",
            top: 0,
            zIndex: 1,
          })}
        >
          <TableRow>
            {headers.map((item) => (
              <TableCell
                sx={(theme) => ({
                  color: theme.palette.background.paper,
                  width: columnWidths[item as keyof typeof columnWidths],
                  minWidth: columnWidths[item as keyof typeof columnWidths],
                  padding: "8px",
                  boxSizing: "border-box",
                  whiteSpace: "normal",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                })}
                key={item}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <CustomTableBody
          alert="No Billed Item"
          dataLoading={isLoading}
          isData={data.length > 0}
          totalSpan={{ col: headers.length, row: 3 }}
        >
          {data.map((row, index) => (
            <TableRow key={`${row.billNo}-${row.itemCode}-${index}`}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{row.billNo}</TableCell>
              <TableCell>{row.itemCode}</TableCell>
              <TableCell sx={{ whiteSpace: "normal" }}>
                {row.itemName}
              </TableCell>
              <TableCell>{row.rate}</TableCell>
              <TableCell>{row.unit}</TableCell>
              <TableCell>{row.amount}</TableCell>
              <TableCell>{(row as any).discountDisplay}</TableCell>
              <TableCell>{row.insDiscount}</TableCell>
              <TableCell>{row.insAmount}</TableCell>
              <TableCell>{row.patShare}</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                {row.empName}
              </TableCell>
            </TableRow>
          ))}
        </CustomTableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailsTable;
